import { useQuery } from '@tanstack/react-query';
import { adaptImpactReport } from 'v2/helpers/adaptImpactReport';
import impactMeterService from 'v2/services/impactMeter';

export function useImpactReport(userId?: number) {
  return useQuery({
    queryKey: ['dashboard', 'impact-report', userId],
    enabled: !!userId,
    retry: false,
    queryFn: () => impactMeterService.getReport(userId).then(adaptImpactReport)
  });
}
